import { createRoute } from "@tanstack/react-router";
import { rootRoute } from "../__root";

export const forgotPasswordRoute = createRoute({
  getParentRoute: () => rootRoute,
  path: "/forgot-password",
}).lazy(() => import("./ForgotPassword.lazy").then((d) => d.Route));
